import { render, staticRenderFns } from "./BannerEditor.vue?vue&type=template&id=edef24da&scoped=true"
import script from "./BannerEditor.vue?vue&type=script&lang=js"
export * from "./BannerEditor.vue?vue&type=script&lang=js"
import style0 from "./BannerEditor.vue?vue&type=style&index=0&id=edef24da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edef24da",
  null
  
)

export default component.exports